<template>
    <div id="generic-page">
        <div class="breadcrum-area">
            <div class="container">
                <div class="breadcrumb">
                    <ul class="list-unstyled">
                        <li><a @click.stop="goToPage('home')">Inicio</a></li>
                        <slot name="breadcrumb-items"></slot>
                    </ul>
                    <h1 class="title h2">
                        <slot name="title"></slot>
                    </h1>
                </div>
            </div>
        </div>
        <section class="section-padding-equal team-details-area">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-12">
                        <slot name="body"></slot>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
    
<script>
import sal from 'sal.js';
export default {
    name: "GenericPage",
    components: {
        
    },
    mounted() {
        sal();
    },
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>
    
<style scoped>
.breadcrum-area {
    background: var(--gradient-rg-green-reverse);
}

.list-unstyled>li {
    font-size: 1.5rem !important;
    color: var(--color-black) !important;
}

.breadcrumb li a:hover {
    color: var(--color-white);
}
</style>